import { useState, useCallback } from 'react';

import analytics from 'utils/client/analytics/analytics';
import { UbiArticlePage } from 'utils/ubi/pages/useUbiArticle';

export enum IsHelpfulAnswerEnum {
  yes = 'yes',
  no = 'no',
}

interface UseSendFeedbackArgs {
  ubi: UbiArticlePage;
  articleIdentifier: string;
}

/**
 * Hook to answer if an article was helpful
 * @param {UbiArticlePage} ubi ubi instance for article page
 * @param {string} articleIdentifier article analytics identifier
 * @return {IsHelpfulAnswerEnum} response.isHelpfulAnswered answered if an article is helpful
 * @return {function} response.answerIfIsHelpful function to answer if an article is helpful
 */
const useIsHelpfulAnswer = ({ ubi, articleIdentifier }: UseSendFeedbackArgs) => {
  const [isHelpfulAnswered, setIsHelpfulAnswered] = useState<IsHelpfulAnswerEnum>();

  const answerIfIsHelpful = useCallback(
    (answer: IsHelpfulAnswerEnum) => {
      analytics.trackEvent({
        category: 'article-feedback',
        action: answer,
        label: `/article/${articleIdentifier}/`,
        nonInteraction: true,
      });

      if (answer === IsHelpfulAnswerEnum.yes) {
        ubi.logArticleHelpfulYes();
      } else {
        ubi.logArticleHelpfulNo();
      }

      setIsHelpfulAnswered(answer);
    },
    [ubi, articleIdentifier],
  );

  return {
    isHelpfulAnswered,
    answerIfIsHelpful,
  };
};

export default useIsHelpfulAnswer;
